<template>
  <ValidationErrors :messages="errorMessages">
    <v-table
        height="300px"
        fixed-height
      >
        <thead>
          <tr>
            <th class="text-left">
              <v-checkbox
                v-model="isAllCheck"
                @update:modelValue="allCheckHandler()"
              ></v-checkbox>
            </th>
            <th
              v-for="column in REMOVE_DEVICE_TABLE_HEADEERS"
              :key="column"
              class="text-left"
            >
              {{ column }}
            </th>
          </tr>
        </thead>
        <tbody v-if="isShowTable">
          <tr
            v-for="device in deviceList"
            :key="device.device_id"
          >
            <td>
              <v-checkbox
                v-model="device.isChecked"
                @update:modelValue="rowCheckHandler(device.isChecked)"
              ></v-checkbox>
            </td>
            <td>{{ device.operation_office?.operation_office_name }}</td>
            <td>{{ device.device_id }}</td>
            <td>{{ device.installation_vehicle?.number_plate }}</td>
            <td>{{ getModelTypeName(device.model_type) }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td :colspan="5">
              <div class="d-flex justify-center align-center height-250px">
                <v-progress-circular
                  color="cyan-lighten-1"
                  indeterminate
                ></v-progress-circular>
              </div>
            </td>
          </tr>
        </tbody>
      </v-table>
  </ValidationErrors>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { ALL_DEVICE_TYPE } from '@/services/consts';
import FirmwareRemoveDeviceType from '@/types/FirmwareRemoveDeviceType';
import ValidationErrors from '@/components/Common/ValidationErrors.vue';
import { REMOVE_DEVICE_TABLE_HEADEERS } from '@/services/consts/firmware_bulk_update';

const emit = defineEmits(['update:modelValue']);
const props = defineProps<{
  modelValue: FirmwareRemoveDeviceType[]
  isShowTable: boolean
  errorMessages?: string[]
}>()

const deviceList = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
})

const isAllCheck = ref(false)

function allCheckHandler() {
  deviceList.value?.forEach((device) => {
    device.isChecked = isAllCheck.value
  })
}
function rowCheckHandler(isCheck:boolean) {
  if (!isCheck) {
    isAllCheck.value = false
  }
  const allChecked = deviceList.value.every((device) => device.isChecked)
  isAllCheck.value = allChecked
}

function getModelTypeName(typeId: number | null) {
  if (!typeId) {
    return ''
  }
  const deviceType = ALL_DEVICE_TYPE.find((deviceType) => {
    return deviceType.id == typeId
  })
  return deviceType ? deviceType.type : ''
}
</script>

<style>
.height-250px{
  height: 250px;
}
</style>
